import React from 'react';
import MobileAppCTA from './MobileAppCTA';

// Item 7 — aspirational, Hinglish upgrade CTA (not a "locked features" grid).
const UNLOCK_BENEFITS = [
  'Planetary Positions',
  'Mahadasha Timeline',
  'Career Predictions',
  'Marriage Insights',
  'Health Guidance',
  'Financial Yog',
  'Lucky Periods',
  'Personalized Remedies',
];

const cardStyle = {
  background: '#fff', borderRadius: '18px', padding: '1.5rem', marginBottom: '1.5rem',
  border: '1.5px solid #fed7aa', boxShadow: '0 4px 20px rgba(180,83,9,.08)',
};
const sectionTitleStyle = { margin: '0 0 1rem', fontSize: '1rem', fontWeight: 700, color: '#92400e' };
const pillStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#78350f', background: '#fff7ed', border: '1px solid #fde68a', borderRadius: '999px', padding: '0.3rem 0.7rem' };

/**
 * Dedicated dashboard for `profileType: 'name_analysis'` profiles (Phase 6/7).
 * Never touches Dashboard.js (the Kundli chart dashboard) — this is a wholly
 * separate, additive component for the name-only journey.
 */
export default function NameAnalysisDashboard({ profile, onBack, onCompleteProfile }) {
  const data = profile?.data || {};
  const { numerology, personality, guidance, traditionalEstimate } = data;

  return (
    <div className="min-h-screen app-shell-bg" style={{ padding: '2rem 1rem' }}>
      <div style={{ width: 'min(780px, 100%)', margin: '0 auto' }}>
        <button
          type="button" onClick={onBack}
          style={{ background: 'none', border: 'none', color: '#92400e', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', marginBottom: '1.25rem' }}
        >
          ← Back
        </button>

        {/* Welcome Card */}
        <div style={{
          background: 'linear-gradient(135deg,#78350f,#b45309)', borderRadius: '20px', padding: '1.75rem',
          color: '#fff', marginBottom: '1.5rem', boxShadow: '0 10px 30px rgba(120,53,15,0.25)',
        }}>
          <span style={pillStyle}>✨ Name Analysis Profile</span>
          <h1 style={{ margin: '0.75rem 0 0.5rem', fontSize: 'clamp(1.5rem,4vw,2rem)', fontWeight: 800 }}>
            Namaste {profile?.name || ''}
          </h1>
          <p style={{ margin: 0, fontSize: '0.9rem', opacity: 0.9, lineHeight: 1.6 }}>
            Aapne Name Analysis profile banaya hai — yeh hain aapke naam ke aadhar par kuch khaas, personalised insights.
          </p>
        </div>

        {/* Name Numerology */}
        {numerology && (
          <div style={cardStyle}>
            <h3 style={sectionTitleStyle}>🔢 Naam Ka Number</h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
              <div style={{
                width: 68, height: 68, borderRadius: '50%', background: 'linear-gradient(135deg,#fde68a,#fbbf24)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.7rem', fontWeight: 800, color: '#78350f', flexShrink: 0,
              }}>
                {numerology.nameNumber}
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <p style={{ margin: '0 0 0.25rem', fontWeight: 700, color: '#78350f', fontSize: '1rem' }}>{numerology.meaning}</p>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#92400e', lineHeight: 1.5 }}>{numerology.description}</p>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))', gap: '0.75rem' }}>
              <div style={{ background: '#fff7ed', borderRadius: '0.75rem', padding: '0.75rem 0.9rem' }}>
                <p style={{ margin: 0, fontSize: '0.7rem', color: '#a16207', fontWeight: 600 }}>Lucky Number</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#78350f', fontWeight: 700 }}>{(numerology.luckyNumbers || []).join(', ')}</p>
              </div>
              <div style={{ background: '#fff7ed', borderRadius: '0.75rem', padding: '0.75rem 0.9rem' }}>
                <p style={{ margin: 0, fontSize: '0.7rem', color: '#a16207', fontWeight: 600 }}>Lucky Colour</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#78350f', fontWeight: 700 }}>{numerology.luckyColor}</p>
              </div>
              <div style={{ background: '#fff7ed', borderRadius: '0.75rem', padding: '0.75rem 0.9rem' }}>
                <p style={{ margin: 0, fontSize: '0.7rem', color: '#a16207', fontWeight: 600 }}>Lucky Day</p>
                <p style={{ margin: 0, fontSize: '0.95rem', color: '#78350f', fontWeight: 700 }}>{numerology.luckyDay}</p>
              </div>
              {numerology.expressionNumber != null && (
                <div style={{ background: '#fff7ed', borderRadius: '0.75rem', padding: '0.75rem 0.9rem' }}>
                  <p style={{ margin: 0, fontSize: '0.7rem', color: '#a16207', fontWeight: 600 }}>Expression Number</p>
                  <p style={{ margin: 0, fontSize: '0.95rem', color: '#78350f', fontWeight: 700 }}>{numerology.expressionNumber}</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Personality */}
        {personality && (
          <div style={cardStyle}>
            <h3 style={sectionTitleStyle}>🧭 Aapki Personality</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: '1.25rem' }}>
              <div>
                <p style={{ margin: '0 0 0.4rem', fontSize: '0.78rem', fontWeight: 700, color: '#92400e' }}>Aapki Sabse Badi Taqat</p>
                <ul style={{ margin: 0, paddingLeft: '1.1rem', fontSize: '0.85rem', color: '#78350f', lineHeight: 1.7 }}>
                  {(personality.strengths || []).map((s) => <li key={s}>{s}</li>)}
                </ul>
              </div>
              <div>
                <p style={{ margin: '0 0 0.4rem', fontSize: '0.78rem', fontWeight: 700, color: '#92400e' }}>Kin Baaton Par Dhyan Dena Chahiye</p>
                <ul style={{ margin: 0, paddingLeft: '1.1rem', fontSize: '0.85rem', color: '#78350f', lineHeight: 1.7 }}>
                  {(personality.challenges || []).map((c) => <li key={c}>{c}</li>)}
                </ul>
              </div>
              <div>
                <p style={{ margin: '0 0 0.4rem', fontSize: '0.78rem', fontWeight: 700, color: '#92400e' }}>Log Aapko Kis Tarah Dekhte Hain</p>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#78350f', lineHeight: 1.6 }}>{personality.communicationStyle}</p>
              </div>
              <div>
                <p style={{ margin: '0 0 0.4rem', fontSize: '0.78rem', fontWeight: 700, color: '#92400e' }}>Career Ke Liye Suitable Fields</p>
                <ul style={{ margin: 0, paddingLeft: '1.1rem', fontSize: '0.85rem', color: '#78350f', lineHeight: 1.7 }}>
                  {(personality.careerTendencies || []).map((c) => <li key={c}>{c}</li>)}
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* Life Guidance */}
        {guidance && (
          <div style={cardStyle}>
            <h3 style={sectionTitleStyle}>💫 Aaj Ke Liye Margdarshan</h3>
            {guidance.split('\n').filter(Boolean).map((para, i) => (
              <p key={i} style={{ margin: '0 0 0.85rem', fontSize: '0.88rem', color: '#78350f', lineHeight: 1.7 }}>{para}</p>
            ))}
          </div>
        )}

        {/* Traditional Name-Based Estimate (optional, heavily caveated) */}
        {traditionalEstimate && (
          <div style={{ ...cardStyle, background: '#fffbeb' }}>
            <h3 style={sectionTitleStyle}>🕉️ Naam Se Traditional Anumaan</h3>
            <p style={{ margin: '0 0 0.5rem', fontSize: '0.9rem', color: '#78350f', fontWeight: 700 }}>
              Aapke naam ki dhwani se Nakshatra sanket: {traditionalEstimate.nakshatra}
            </p>
            <p style={{ margin: 0, fontSize: '0.78rem', color: '#a16207', lineHeight: 1.6, fontStyle: 'italic' }}>
              {traditionalEstimate.disclaimer}
            </p>
          </div>
        )}

        {/* Unlock Complete Kundli — aspirational, Hinglish premium CTA */}
        <div style={{
          background: 'linear-gradient(135deg,#fff7ed,#fef3c7)', borderRadius: '18px', padding: '1.75rem', marginBottom: '1.5rem',
          border: '2px solid #f59e0b', boxShadow: '0 4px 20px rgba(180,83,9,.1)',
        }}>
          <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.1rem', fontWeight: 800, color: '#78350f' }}>
            🔓 Apni Complete Kundli Unlock Karein
          </h3>
          <p style={{ margin: '0 0 1rem', fontSize: '0.85rem', color: '#92400e', lineHeight: 1.6 }}>
            Complete Birth Details add karke unlock karein:
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))', gap: '0.6rem', marginBottom: '1.25rem' }}>
            {UNLOCK_BENEFITS.map((b) => (
              <div key={b} style={{
                background: 'rgba(255,255,255,0.7)', border: '1px solid #fde68a', borderRadius: '0.7rem', padding: '0.65rem 0.85rem',
                fontSize: '0.83rem', fontWeight: 600, color: '#78350f', display: 'flex', alignItems: 'center', gap: '0.5rem',
              }}>
                <span>✨</span> {b}
              </div>
            ))}
          </div>
          <button
            type="button" onClick={onCompleteProfile}
            style={{
              width: '100%', padding: '0.85rem', borderRadius: '0.75rem', border: 'none',
              background: 'linear-gradient(135deg,#d97706,#b45309)', color: '#fff', fontWeight: 700,
              fontSize: '0.95rem', cursor: 'pointer', boxShadow: '0 6px 18px rgba(180,83,9,0.35)',
            }}
          >
            Complete My Kundli
          </button>
        </div>

        <MobileAppCTA />
      </div>
    </div>
  );
}
